import styled from 'styled-components';

export const SemiCircle = styled.p`
  padding: 0.2em 0.9em 0em 0.9em;
  height: 1.7em;
  background: ${(props) => props.theme.$primary_green};
  position: absolute;
  left: 0px;
  top: -1.7em;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  color: ${(props) => props.theme.$white};
  font-weight: bold;
`;
